module.exports = __webpack_public_path__ + "static/media/rapbracketslogo_big.6ac2920d.jpg";